import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";

import {
  collection,
 
  query,
  where,
  onSnapshot,
  serverTimestamp,
  doc,
  
  runTransaction,
} from "firebase/firestore";

import { auth, db } from "../firebase";
import { Link } from "react-router-dom";
import "../App.css";
import binanceIcon from "../assets/binance.png";
import jazzcashIcon from "../assets/jazzcash.png";

function Withdraw() {
  const [currentUser, setCurrentUser] = useState(null);
const [availableBalance, setAvailableBalance] = useState(0);
const [loading, setLoading] = useState(false);
  const [method, setMethod] = useState("binance");
  const [amount, setAmount] = useState("");
  const [wallet, setWallet] = useState("");
  const [accountName, setAccountName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [withdrawHistory, setWithdrawHistory] = useState([]);

  useEffect(() => {
  let unsubscribeUser = null;
  let unsubscribeWithdraws = null;

  const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
    if (unsubscribeUser) {
      unsubscribeUser();
      unsubscribeUser = null;
    }

    if (unsubscribeWithdraws) {
      unsubscribeWithdraws();
      unsubscribeWithdraws = null;
    }

    if (!user) {
      setCurrentUser(null);
      setAvailableBalance(0);
      setWithdrawHistory([]);
      return;
    }

    setCurrentUser(user);

    const userRef = doc(db, "users", user.uid);

    unsubscribeUser = onSnapshot(userRef, (snapshot) => {
      if (snapshot.exists()) {
        const userData = snapshot.data();
        setAvailableBalance(Number(userData.balance || 0));
      } else {
        setAvailableBalance(0);
      }
    });

    const withdrawQuery = query(
      collection(db, "withdraws"),
      where("uid", "==", user.uid)
    );

    unsubscribeWithdraws = onSnapshot(withdrawQuery, (snapshot) => {
      const history = snapshot.docs.map((withdrawDocument) => ({
        id: withdrawDocument.id,
        ...withdrawDocument.data(),
      }));

      history.sort((a, b) => {
        const firstTime = a.createdAt?.toMillis
          ? a.createdAt.toMillis()
          : Number(a.createdAtMillis || 0);

        const secondTime = b.createdAt?.toMillis
          ? b.createdAt.toMillis()
          : Number(b.createdAtMillis || 0);

        return secondTime - firstTime;
      });

      setWithdrawHistory(history);
    });
  });

  return () => {
    unsubscribeAuth();

    if (unsubscribeUser) {
      unsubscribeUser();
    }

    if (unsubscribeWithdraws) {
      unsubscribeWithdraws();
    }
  };
}, []);

  const submitWithdraw = async () => {
  const numericAmount = Number(amount);

  const hasPendingWithdraw = withdrawHistory.some(
    (item) => item.status === "Pending"
  );

  if (hasPendingWithdraw) {
    alert("Your withdraw request is already pending.");
    return;
  }

  if (!amount || numericAmount < 5) {
    alert("Minimum withdrawal amount is $5.");
    return;
  }

  if (numericAmount > availableBalance) {
    alert("Insufficient profit balance.");
    return;
  }

  if (method === "binance" && !wallet.trim()) {
    alert("Please enter BEP20 wallet address.");
    return;
  }

  if (
    (method === "jazzcash" || method === "easypaisa") &&
    (!accountName.trim() || !accountNumber.trim())
  ) {
    alert("Please enter account details.");
    return;
  }

  setLoading(true);

  try {
    await runTransaction(db, async (transaction) => {
      const userRef = doc(db, "users", currentUser.uid);
      const userSnap = await transaction.get(userRef);

      if (!userSnap.exists()) {
        throw new Error("User not found");
      }

      const userData = userSnap.data();

const latestProfit = Number(
  userData.totalProfit || 0
);

const latestReferralCommission = Number(
  userData.referralCommission || 0
);

const latestTotalWithdraw = Number(
  userData.totalWithdraw || 0
);

const withdrawableEarnings =
  latestProfit +
  latestReferralCommission -
  latestTotalWithdraw;

if (numericAmount > withdrawableEarnings) {
  throw new Error(
    "Insufficient withdrawable earnings"
  );
}


      const withdrawRef = doc(collection(db, "withdraws"));

      transaction.set(withdrawRef, {
  uid: currentUser.uid,
  userEmail: currentUser.email || "",

  method:
    method === "binance"
      ? "Binance USDT"
      : "JazzCash",

  network:
    method === "binance"
      ? "BEP20"
      : "PKR Wallet",

  amount: numericAmount,

  walletAddress:
    method === "binance"
      ? wallet.trim()
      : "",

  accountName:
    method === "jazzcash"
      ? accountName.trim()
      : "",

  accountNumber:
    method === "jazzcash"
      ? accountNumber.trim()
      : "",

  status: "Pending",

  date: new Date().toLocaleDateString("en-GB"),

  createdAt: serverTimestamp(),
  createdAtMillis: Date.now(),
});
    });

    alert("Withdraw request submitted successfully.");

    setAmount("");
    setWallet("");
    setAccountName("");
    setAccountNumber("");

  } catch (error) {
    alert(error.message);
  }

  setLoading(false);
};
  return (
    <div className="app withdraw-page">
      <header className="page-header">
        <Link to="/" className="back-button">
          ←
        </Link>

        <div>
          <h1>Withdraw</h1>
          <p>Withdraw your available profit</p>
        </div>
      </header>

      <section className="withdraw-balance-card">
        <span>Available Profit Balance</span>
        <h2>${availableBalance.toFixed(2)}</h2>
        <p>Minimum withdrawal: $5</p>
      </section>

      <section className="withdraw-card">
        <h2>Select Withdrawal Method</h2>

        <div className="withdraw-methods">
          <button
            type="button"
            className={`withdraw-method ${
              method === "binance"
                ? "active-withdraw-method"
                : ""
            }`}
            onClick={() => setMethod("binance")}
          >
           <img
  src={binanceIcon}
  alt="Binance"
  className="payment-logo"
/>
            Binance USDT
            <small>BEP20</small>
          </button>

          <button
            type="button"
            className={`withdraw-method ${
              method === "jazzcash"
                ? "active-withdraw-method"
                : ""
            }`}
            onClick={() => setMethod("jazzcash")}
          >
            <img
  src={jazzcashIcon}
  alt="JazzCash"
  className="payment-logo"
/>
            JazzCash
            <small>PKR Wallet</small>
          </button>
        </div>
      </section>

      <section className="withdraw-card">
        <label htmlFor="withdrawAmount">
          Withdraw Amount
        </label>

        <div className="input-wrapper">
          <span>$</span>

          <input
            id="withdrawAmount"
            type="number"
            min="5"
            placeholder="Enter amount"
            value={amount}
            onChange={(event) =>
              setAmount(event.target.value)
            }
          />

          <strong>USDT</strong>
        </div>

        {method === "binance" ? (
          <>
            <label htmlFor="walletAddress">
              USDT BEP20 Wallet Address
            </label>

            <input
              id="walletAddress"
              className="deposit-input"
              type="text"
              placeholder="Enter BEP20 wallet address"
              value={wallet}
              onChange={(event) =>
                setWallet(event.target.value)
              }
            />
          </>
        ) : (
          <>
            <label htmlFor="accountName">
              Account Holder Name
            </label>

            <input
              id="accountName"
              className="deposit-input"
              type="text"
              placeholder="Enter account holder name"
              value={accountName}
              onChange={(event) =>
                setAccountName(event.target.value)
              }
            />

            <label htmlFor="accountNumber">
              JazzCash Number
            </label>

            <input
              id="accountNumber"
              className="deposit-input"
              type="text"
              placeholder="03XXXXXXXXX"
              value={accountNumber}
              onChange={(event) =>
                setAccountNumber(event.target.value)
              }
            />
          </>
        )}

        <div className="withdraw-summary">
          <div>
            <span>Withdrawal Fee</span>
            <strong>$0.00</strong>
          </div>

          <div>
            <span>You Will Receive</span>
            <strong>
              ${Number(amount || 0).toFixed(2)}
            </strong>
          </div>
        </div>

        <button
  type="button"
  className="submit-withdraw-button"
  onClick={submitWithdraw}
  disabled={loading}
>
  {loading ? "Please Wait..." : "Submit Withdraw Request"}
</button>

        <p className="withdraw-note">
          Only profit balance can be withdrawn. One
          withdrawal request is allowed at a time.
        </p>
      </section>

      {withdrawHistory.length > 0 && (
        <section className="premium-history-section withdraw-history-section last-history">
          <h2 className="history-title">
            <span className="history-title-icon withdraw-title-icon">
              ▧
            </span>
            Recent Withdraw History
          </h2>

          <div className="history-list">
            {withdrawHistory.map((item) => (
              <div
                className="premium-history-card withdraw-history-card"
                key={item.id}
              >
                <div className="history-method-row">
                  <div className="history-method-left">
                    <div className="history-method-icon">
                      {item.method
                        .toLowerCase()
                        .includes("jazz")
                        ? "J"
                        : "₮"}
                    </div>

                    <div className="history-method-information">
                      <strong className="history-method-name">
                        {item.method}
                      </strong>

                      <span className="history-network">
                        {item.network}
                      </span>
                    </div>
                  </div>

                  <span className="history-amount">
                    ${Number(item.amount).toFixed(2)}
                  </span>
                </div>

                <div className="history-detail-row">
                  <span className="history-detail-label">
                    <span className="detail-icon">
                      ⟳
                    </span>
                    Status
                  </span>

                  <span
                    className={`history-status ${
                      item.status.toLowerCase() ===
                      "approved"
                        ? "status-approved"
                        : item.status.toLowerCase() ===
                          "rejected"
                        ? "status-rejected"
                        : "status-pending"
                    }`}
                  >
                    {item.status}
                  </span>
                </div>

                <div className="history-detail-row history-date-row">
                  <span className="history-detail-label">
                    <span className="detail-icon">
                      ▦
                    </span>
                    Date
                  </span>

                  <span className="history-date">
                    <span className="calendar-icon">
                      ▦
                    </span>
                  {item.date ||
  (item.createdAt?.toDate
    ? item.createdAt.toDate().toLocaleDateString("en-GB")
    : "No Date")}
                  </span>
                  {item.walletAddress && (
  <div className="history-detail-row">
    <span className="history-detail-label">BEP20 Address</span>
    <span className="history-date">{item.walletAddress}</span>
  </div>
)}

{item.accountName && (
  <div className="history-detail-row">
    <span className="history-detail-label">Account Name</span>
    <span className="history-date">{item.accountName}</span>
  </div>
)}

{item.accountNumber && (
  <div className="history-detail-row">
    <span className="history-detail-label">JazzCash Number</span>
    <span className="history-date">{item.accountNumber}</span>
  </div>
)}
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      <nav className="bottom-nav">
       <Link to="/dashboard" className="nav-item">
          <span className="nav-icon">🏠</span>
          <span>Dashboard</span>
        </Link>

        <Link to="/deposit" className="nav-item">
          <span className="nav-icon">💰</span>
          <span>Deposit</span>
        </Link>

        <Link to="/machine" className="nav-item">
          <span className="nav-icon">▶️</span>
          <span>Machine</span>
        </Link>

        <Link to="/refer" className="nav-item">
          <span className="nav-icon">👥</span>
          <span>Referral</span>
        </Link>

        <Link to="/profile" className="nav-item">
          <span className="nav-icon">👤</span>
          <span>Profile</span>
        </Link>
      </nav>
    </div>
  );
}

export default Withdraw;